// features/orders/ordersSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { fetchAllActiveOrders } from '../features/adminAsync';

const initialState = {
  activeOrders: [],
};

const ordersSlice = createSlice({
  name: 'orders',
   initialState,
   error:null,
   loading:false,
    reducers: {
     // any synchronous reducers
   },
   extraReducers: (builder) => {
     builder
       .addCase(fetchAllActiveOrders.pending, (state) => {
         state.loading = true;
         state.error = null;
       })
       .addCase(fetchAllActiveOrders.fulfilled, (state, action) => {
         state.activeOrders = action.payload;
         state.loading = false;
       })
       .addCase(fetchAllActiveOrders.rejected, (state, action) => {
         state.loading = false;
         state.error = action.payload;
       });
   },
 });
export default ordersSlice.reducer;
